import "./styles.scss";

import { useTranslation } from "react-i18next";
import classnames from "classnames";

import ModalMobile from "components/ModalMobile";
import TextEditor from "components/TextEditor";

const mainClass = "task-view-message-modal-edit";

const ModalEdit = ({
  id,
  content,
  setContent,
  files,
  setFiles,
  droppedFiles,
  onFilesDropHandled,
  isDisabled,
  isMessageSending,
  isSubmitDisabled,
  isOpen,
  onPreviewClick,
  onDeleteClick,
  onSubmit,
  onClose,
  onActivate,
  isFileDropTarget,
}) => {
  const { t } = useTranslation();

  return (
    <ModalMobile
      title={t("Edit comment")}
      hasMobileScrollTop={false}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div
        className={classnames(mainClass, {
          [`${mainClass}--file-drop-target`]: isFileDropTarget,
        })}
        onClickCapture={onActivate}
        onFocusCapture={onActivate}
      >
        <TextEditor
          id={id}
          content={content}
          setContent={setContent}
          files={files}
          setFiles={setFiles}
          droppedFiles={droppedFiles}
          onFilesDropHandled={onFilesDropHandled}
          isDisabled={isDisabled}
          isMessageSending={isMessageSending}
          isInline
          isSubmitDisabled={isSubmitDisabled}
          onPreviewClick={onPreviewClick}
          onDeleteClick={onDeleteClick}
          onSubmit={onSubmit}
        />
      </div>
    </ModalMobile>
  );
};

export default ModalEdit;
